;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';

import { BLOCKS } from '@contentful/rich-text-types';

import Icon from 'components/ui/SvgIcon';
import Text from 'components/ui/Text';

import styles from './Directions.module.scss';

export const overrides = {
    renderNode: {
        [BLOCKS.HEADING_2]: (node, children) => {
            return (
                <Text
                    as="h2"
                    baseTheme="headingSmall"
                    themes={{ large: 'headingMedium' }}
                    className={styles.directionsHeadline}
                >
                    {children}
                </Text>
            );
        },
        [BLOCKS.HEADING_4]: (node, children) => {
            return (
                <Text
                    as="h4"
                    baseTheme="headingSmall"
                    className={styles.directionsName}
                >
                    {children}
                </Text>
            );
        },
        [BLOCKS.PARAGRAPH]: (node, children) => {
            return (
                <Text
                    as="p"
                    baseTheme="bodyMedium"
                    className={styles.paragraph}
                >
                    {children}
                </Text>
            );
        },
        [BLOCKS.UL_LIST]: (node, children) => {
            return <ul className={styles.list}>{children}</ul>;
        },
        [BLOCKS.OL_LIST]: (node, children) => {
            return <ol className={styles.list}>{children}</ol>;
        },
        [BLOCKS.LIST_ITEM]: (node, children) => {
            return (
                <li
                    itemProp="recipeInstructions"
                    className={cx(styles.listItem, {
                        [styles.hasTillaTip]: node.content.length > 1,
                    })}
                >
                    <Icon type="utensils" className={styles.counter} />
                    {children}
                </li>
            );
        },
    },
    renderText: text => {
        const fractionPattern = /\*([\d])[\\]?[/]?([\d][\d]?)\*+/g;
        const pattern = /\*([\S]+)\*+/g;

        // Do we have the pattern to start
        if (text && text.match(pattern)) {
            // true fraction
            if (text.match(fractionPattern)) {
                let pieces = text.split(' ');

                return (
                    <span>
                        {pieces.map((piece, idx) => {
                            if (piece.match(fractionPattern)) {
                                const frac = piece.replace(/\*+/g, '');
                                const split = frac.split('/');

                                return (
                                    <span className={styles.fraction} key={idx}>
                                        <sup>{split[0]}</sup>
                                        &frasl;
                                        <sub>{split[1]}</sub>
                                    </span>
                                );
                            }

                            return `${piece} `;
                        })}
                    </span>
                );
            }

            // ligature
            return text.replace(/\*+/g, '');
        }

        return text;
    },
};
